import { Popover as ArkPopover } from '@ark-ui/react/popover';
import { Portal } from '@ark-ui/react/portal';
import { css } from '@styled-system/css';
import type { ReactNode } from 'react';

interface PopoverProps {
  trigger: ReactNode;
  children: ReactNode;
  placement?:
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'left'
    | 'left-start'
    | 'left-end'
    | 'right'
    | 'right-start'
    | 'right-end';
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  className?: string;
}

const surface = css({
  bg: 'surface.elevated',
  color: 'text.primary',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'border.default',
  borderRadius: 'lg',
  boxShadow: 'md',
  padding: '6',
  fontFamily: 'sans',
  fontSize: 'bodySm',
  zIndex: 1300,
  outline: 'none',
});

export const Popover = ({ trigger, children, placement = 'bottom', open, onOpenChange, className }: PopoverProps) => (
  <ArkPopover.Root
    positioning={{ placement }}
    open={open}
    onOpenChange={onOpenChange ? (details) => onOpenChange(details.open) : undefined}
  >
    <ArkPopover.Trigger asChild>{trigger}</ArkPopover.Trigger>
    {/* Portal : sort le popover du DOM parent pour qu'il échappe aux
     *  stacking contexts implicites (ex: les FolderSection avec dnd-kit
     *  qui passaient par-dessus le dropdown des actions filtres). */}
    <Portal>
      <ArkPopover.Positioner>
        <ArkPopover.Content className={`${surface} ${className ?? ''}`}>{children}</ArkPopover.Content>
      </ArkPopover.Positioner>
    </Portal>
  </ArkPopover.Root>
);
